var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideRightMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15V17H18V15H0ZM14.404 0.903992L12.99 2.31799L16.172 5.49999L12.99 8.68199L14.404 10.096L19 5.49999L14.404 0.903992ZM0 7.99999V9.99999H9V7.99999H0ZM0 0.999992V2.99999H9V0.999992H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideRightMenuIcon);
export default __webpack_public_path__ + "static/media/hide-right-menu-icon.ace21fd3ed5b0b85f69e5ba837ad8961.svg";
export { ForwardRef as ReactComponent };